<template>
  <div class="nav-menu">
    <div class="nav-left">
      <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" theme="dark" @select="handleSelect" :unique-opened="uniqueOpenedB" router>
        <div class="left-top"></div>
        <el-menu-item index="/accountMgr" v-if="rule!=4"><i class="el-icon-menu"></i>用户管理</el-menu-item>
        <el-submenu index="/deviceMgr" >
          <template slot="title"><i class="el-icon-message"></i>设备管理</template>
          <el-menu-item index="/deviceMgr/deviceBind">已激活设备</el-menu-item>
          <el-menu-item index="/deviceMgr/deviceNoBind" v-if="rule!=4">未激活设备</el-menu-item>
          <!-- <el-menu-item index="/deviceMgr/alarmSummary" >告警汇总</el-menu-item> -->
        </el-submenu>
        <el-submenu index="/adMgr" v-if="rule!=4">
          <template slot="title"><i class="el-icon-message"></i>广告素材</template>
          <el-menu-item style="width:160px" index="/adMgr/adVideo">视频广告</el-menu-item>
          <el-menu-item index="/adMgr/adPic">图片广告</el-menu-item>
          <el-menu-item index="/adMgr/adWeixin">微信广告</el-menu-item>

          <el-menu-item v-if="rule === 0 || rule === 1 || rule === 2" index="/adMgr/deviceEntryAddress">扫码入口</el-menu-item>
        </el-submenu>
        <el-submenu index="/dataStatistics">
          <template slot="title"><i class="el-icon-message"></i>数据统计</template>
        <!--  <el-menu-item index="/dataStatistics/dataDevice">设备统计</el-menu-item>-->
          <el-menu-item index="/dataStatistics/dataWeixin" v-if="rule!=4">公众号统计</el-menu-item>
          <el-menu-item index="/dataStatistics/outGoods">出货统计</el-menu-item>
          <el-menu-item index="/dataStatistics/deviceOutGoods">设备出货统计</el-menu-item>
        </el-submenu>

        <el-submenu index="/globalConfig" v-if="getAuthorityNoFlow()==false && rule!=4" >
          <template slot="title"><i class="el-icon-message"></i>全局配置</template>
          <el-menu-item v-if="rule === 0 || rule === 1 || rule === 2" index="/globalConfig/payStatus">屏幕流程图片</el-menu-item>
          <el-menu-item style="width:160px" index="/globalConfig/flowConfig">取货流程</el-menu-item>
          <el-menu-item style="width:160px" index="/globalConfig/userException">用户例外流程</el-menu-item>
          <el-menu-item style="width:160px" index="/globalConfig/deviceException">设备例外流程</el-menu-item>
        </el-submenu>


        <el-submenu index="/fxshop" v-if="getAuthorityFxShop()==true && rule!=4">
          <template slot="title"><i class="el-icon-message"></i>分销商城</template>
          <el-menu-item  index="/fxshop/commodityAdd">添加商品</el-menu-item>
          <el-menu-item  index="/fxshop/commodityList">商品列表</el-menu-item>
          <el-menu-item  index="/fxshop/tradeRecord">订单列表</el-menu-item>
          <el-menu-item  index="/fxshop/fxShareFee">分润配置</el-menu-item>
          <el-menu-item  index="/fxshop/fxLevel">分销等级配置</el-menu-item>
          <el-menu-item  index="/fxshop/fxGallery">商城画廊配置</el-menu-item>
          <el-menu-item  index="/fxshop/fxShopInfo">商城信息配置</el-menu-item>



          <!-- <el-menu-item  index="/fxshop/fxIncomeSubsidy">补贴明细</el-menu-item> -->
          <el-menu-item  index="/fxshop/fxIncomeCommission">佣金明细</el-menu-item>
          <el-menu-item  index="/fxshop/fxIncomeCommissionWithdraw">佣金提现</el-menu-item>
        </el-submenu>

        <el-submenu index="/mutiGoods"   v-if="rule!=4">
          <template slot="title"><i class="el-icon-message"></i>多商品管理</template>
          <el-menu-item  index="/mutiGoods/mutiGoodsAdd">添加商品</el-menu-item>
          <el-menu-item  index="/mutiGoods/mutiGoodsList">商品列表</el-menu-item>
       
        </el-submenu>


        <el-submenu index="/opMgr"   v-if="userId=='1'||userId=='1411'">
          <template slot="title"><i class="el-icon-message"></i>运营管理</template>
          <el-menu-item  index="/opMgr/gpsRecord">运维轨迹</el-menu-item>
          <el-menu-item  index="/opMgr/opRecord">运维记录</el-menu-item>
       
        </el-submenu>

        <el-submenu index="/financeMgr"  v-if="rule!=4">
          <template slot="title"><i class="el-icon-message"></i>财务管理</template>
          <el-menu-item style="width:160px" index="/financeMgr/withdrawRecord">提现记录</el-menu-item>
          <el-menu-item index="/financeMgr/checkRecord">审核记录</el-menu-item>
          <el-menu-item index="/financeMgr/incomeFlow">收入流水</el-menu-item>
        </el-submenu>
        <el-menu-item v-if="rule === 0" index="/versionMgr"><i class="el-icon-setting"></i>版本管理</el-menu-item>
      </el-menu>
    </div>
    <div class="nav-content">
      <div class="nav-top">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark" style="text-align: center;">
              <el-row>
                <div class="nav-title">
                  <span >欢迎使用{{copyright}}后台管理系统</span>
                </div>
                <el-col :span="12" :offset="12" style="text-align: right;">
                  <span>{{adminName}}</span>
                  <span style="margin:0 30px;color:#337ab7;cursor:pointer;" @click="editPwd">{{userName}}</span>
                  <el-button @click.native="logout" type="danger" style="margin-right: 10px">退出登录</el-button>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

      </div>
      <div class="nav-main">
        <el-col :span="24" class="content-wrapper">
          <!--<transition name="fade" mode="out-in">-->
            <router-view></router-view>
          <!--</transition>-->
        </el-col>
      </div>
    </div>
    <pu-first-login :add-show="loginShow" :user-acc="userAcc" :user-name="userName" :user-id="userId" @closefirstPu="closefirPu"></pu-first-login>
  </div>
</template>
<script>
  import {isNull, getAuthority} from '../js/tool'
  import {getCopyRight} from '../../static/copyright'
  import puFirstLogin from '../page/deviceMgr/judgeFirstLogin'
  export default {
    name: 'nav',
    data () {
      return {
        uniqueOpenedB: true,
        defaultActive: '/accountMgr',
        loginShow: false,
        userType: '',
        adminName:'',
        userId: '',
        userAcc: '',
        userName: '',
        rule: -1,
        copyright: ''
      }
    },
    created: function () {
      this.defaultActive = isNull(this.$store.state.defaultActive) ? '/accountMgr' : this.$store.state.defaultActive
      this.initUserInfo()
      this.judgeLogin()
      this.rule = JSON.parse(window.sessionStorage.getItem('lbz-device-user-info')).user_type
      this.copyright = getCopyRight()
    },
    methods: {
      getAuthorityFxShop () {
        return getAuthority("fxShop")
      },
      getAuthorityNoFlow () {
        return getAuthority("noFlow")
      },
      logout () {
        var _this = this
        this.$confirm('确认退出吗?', '提示', {
        }).then(() => {
          _this.$store.commit('setAccessToken', '')
          sessionStorage.removeItem('lbz_accessToken')
          sessionStorage.removeItem('lbz-device-user-info')
          _this.$router.push('/login')
        }).catch(() => {

        })
      },
      handleSelect (key, keyPath) {
        this.defaultActive = keyPath[keyPath.length - 1]
        this.$store.commit('setDefaultActive', this.defaultActive)
      },
      editPwd () {
        this.$router.push({path: '../accountMgr/editPwd', query: {'acc': this.userAcc, 'name': this.userName, 'id': this.userId}})
      },
      closefirPu () {
        this.loginShow = false
      },
      judgeLogin () {
        var userInfo = JSON.parse(sessionStorage.getItem('lbz-device-user-info'))
        if (userInfo.pwdStatus === 0 && userInfo.user_type!=4) {
          this.loginShow = true
          return
        }
      },
      initUserInfo () {
        var userInfo = JSON.parse(sessionStorage.getItem('lbz-device-user-info'))
        if (userInfo.user_type === 0) {
          this.userType = '超级管理员'
          this.adminName = '超级管理员'
        } else if (userInfo.user_type === 1) {
          this.userType = '代理商'
          this.adminName = '管理员'
        } else if (userInfo.user_type === 2) {
          this.userType = '设备主'
          this.adminName = '管理员'
        } else if (userInfo.user_type === 3) {
          this.userType = '维护人员'
          this.adminName = '管理员'
        }
        this.userId = userInfo.id
        this.userAcc = userInfo.user_name
        this.userName = userInfo.nickName
      }
    },
    components: {
      'pu-first-login': puFirstLogin
    }
  }
</script>
<style>
  .nav-menu {
    display: flex;
    display: -webkit-box;
    display: -ms-flexbox;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    background-color: #FCFCFC;
  }
  .nav-menu .nav-left {
    background-color: #324157;
    flex: 0 0 160px;
    width: 160px;
    z-index: 100;
  }
  .nav-menu .el-submenu .el-menu-item {
    width: 160px;
    padding-right: 0;
    min-width: 160px;
  }
  .nav-menu .nav-left .left-top {
    height: 80px;
    position: relative;
    clear: both;
    overflow: hidden;
  }
  .nav-menu .nav-content {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow-y: auto;
    background: #eef1f6;
    position: relative;
  }
  .nav-menu .nav-content .nav-top {
    height: 50px;
    line-height: 50px;
    background: white;
    z-index: 100;
    position: fixed;
    top: 0;
    right: 0;
    left: 160px;
  }
  .nav-menu .nav-content .nav-main {
    padding:10px 10px 10px 10px;
    margin-top: 60px;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 160px;
    text-align: left;
    height: 100%;
  }
  .nav-title {
    position: absolute;
    text-align: center;
    left: 50%;
    width: 300px;
    margin-left: -150px;
  }
</style>



// WEBPACK FOOTER //
// src/page/navMenu.vue